import { MAX_NUMBER_OF_TILES } from '@allesauto/utils/consts';
import { getColumnsAndMaxTiles } from '@allesauto/utils/funcs';
import { SCREEN_BREAKPOINT, useScreenBreakpoint } from '@allesauto/utils/hooks';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';

import Tile, { TileProps } from '../tile';

export interface TilesGridProps {
  tiles: TileProps[];
  component: string;
  _uid: string;
  _editable?: string;
}

export default function TilesGrid(props: TilesGridProps) {
  const { tiles } = props;
  const breakpoint = useScreenBreakpoint();
  const mobileBreakpoint = breakpoint <= SCREEN_BREAKPOINT.MD;

  const { nbColumns, maxTiles } = getColumnsAndMaxTiles(
    tiles.length,
    MAX_NUMBER_OF_TILES
  );

  const className = {
    grid: clsx(
      `auto-rows-fr grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${nbColumns}`
    ),
  };

  return (
    <div {...sbEditable(props)} className={className.grid}>
      {tiles
        .filter((tile, index) => index < maxTiles)
        .map((tile, index) => {
          if (mobileBreakpoint && index > 2 && tile.order) {
            const orders = maxTiles - tile.order + 4;
            return <Tile key={index} {...tile} order={orders} />;
          }
          return <Tile key={index} {...tile} />;
        })}
    </div>
  );
}
